import React, { Component } from 'react'
import i18n from '../../i18n'
import LoaderDots from '../loaderDots'

class List extends Component {
  eventsGrid(events) {
    return (
      <div className="col-md-9 col-sm-12 events-container">
        {events.map((event) => {
          if (event.pageUrl) {
            return (
              <div key={event.id}>
                <a
                  href={event.pageUrl}
                  className={`row no-gutters event ${event.status}`}
                  style={{ borderLeft: this.styledBorder(event) }}
                >
                  {this.eventInfo(event)}
                </a>

                <div className="asterisk" key={`asterisk-${event.id}`}>
                  {event.asterisk ? `* ${event.asterisk}` : null}
                </div>
              </div>
            )
          } else {
            return (
              <div key={event.id}>
                <div
                  className={`row no-gutters event ${event.status}`}
                  style={{ borderLeft: this.styledBorder(event) }}
                >
                  {this.eventInfo(event)}
                </div>

                <div className="asterisk" key={`asterisk-${event.id}`}>
                  {event.asterisk ? `* ${event.asterisk}` : null}
                </div>
              </div>
            )
          }
        })}
      </div>
    )
  }

  styledBorder(event) {
    let coloredBorder = `5px solid ${event.logoBaseColor}`
    let regularBorder = 'solid #cccccc 1px'

    if (event.pageUrl && event.logoBaseColor !== 'FFFFFF') {
      return coloredBorder
    }

    if (event.status === 'finished') return regularBorder

    null
  }

  eventInfo(event) {
    return (
      <React.Fragment>
        <div className="col-12 event-row">
          <div>
            <div className="date">{event.intervalDays}</div>
            <div className="name my-1">{event.name}</div>
            <div className="local">
              <span className="icon">
                <i className="fa fa-map-marker"></i>
              </span>
              {event.local}, {event.city}
            </div>
          </div>

          <div
            className={`arrow-icon d-md-none ${
              event.pageUrl && event.status === 'published'
                ? 'd-flex'
                : 'd-none'
            }`}
          >
            <span className="icon">
              <i className="fa fa-arrow-right"></i>
            </span>
          </div>
        </div>
      </React.Fragment>
    )
  }

  intervalDays(event) {
    if (event.startDay === event.endDay) {
      return (
        <React.Fragment>
          <span className="start">
            {event.startDay}
            <sup className="star">{event.asterisk ? '*' : null}</sup>
          </span>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <span className="start">
            {event.startDay}
            <sup className="star">
              {event.asterisk && event.asteriskPosition === 'first_date'
                ? '*'
                : null}
            </sup>
          </span>
          <span className="interval-divider"> - </span>
          <span className="end">
            {event.endDay}
            <sup className="star">
              {event.asterisk && event.asteriskPosition === 'second_date'
                ? '*'
                : null}
            </sup>
          </span>
        </React.Fragment>
      )
    }
  }

  monthsRows(yearEvents) {
    return Object.keys(yearEvents).map((monthYear, index) => {
      let [_year, month] = monthYear.split('-')
      let events = yearEvents[monthYear]

      return events.length > 0 ? (
        <div className="col-sm-12 col-md-12" key={index}>
          <div className="row no-gutters my-5">
            <div className="col-md-3 col-sm-12 month-row" id={month}>
              {month}
            </div>
            {this.eventsGrid(events)}
          </div>
        </div>
      ) : null
    })
  }

  currentYearMonth(month) {
    const currentYear = new Date().getFullYear()

    return `${currentYear}-${month}`
  }

  nextYearMonth(month) {
    const currentYear = new Date().getFullYear()
    const nextYear = currentYear + 1

    return `${nextYear}-${month}`
  }

  eventsByMonth(events) {
    const { months } = this.props

    let eventsMonths = months.reduce((memo, month) => {
      let currentYearMonth = this.currentYearMonth(month)
      let nextYearMonth = this.nextYearMonth(month)

      memo[currentYearMonth] = events.filter(
        (event) => event.yearMonth.toLowerCase() === currentYearMonth
      )

      memo[nextYearMonth] = events.filter(
        (event) => event.yearMonth.toLowerCase() === nextYearMonth
      )

      return memo
    }, {})

    return eventsMonths
  }

  eventsBy(year) {
    const { initialEvents, filteredEvents } = this.props

    let allEvents = this.eventsByMonth(
      filteredEvents.length > 0 ? filteredEvents : []
    )

    const asArray = Object.entries(allEvents)

    const filtered = asArray.filter(([key, _value]) => key.includes(year))

    return Object.fromEntries(filtered)
  }

  hasEvents(events) {
    const asArray = Object.entries(events)
    const filtered = asArray.filter(([_key, value]) => value.length > 0)

    return filtered.length > 0
  }

  render() {
    const currentYear = new Date().getFullYear()
    const nextYear = currentYear + 1

    let currentYearEvents = this.eventsBy(currentYear)
    let nextYearEvents = this.eventsBy(nextYear)

    if (this.props.loading)
      return (
        <div className="col-12">
          <LoaderDots />
        </div>
      )

    return (
      <React.Fragment>
        {this.hasEvents(currentYearEvents) ? (
          <div className="container">
            <div className="row no-gutters">
              {this.monthsRows(currentYearEvents)}
            </div>
          </div>
        ) : null}

        {this.hasEvents(nextYearEvents) ? (
          <div className="container">
            <div className="row no-gutters">
              <div className="next-year-calendar">
                <div className="title" id={nextYear.toString()}>
                  {i18n.t('calendar.titleWithYear', { year: nextYear })}
                </div>
              </div>
              {this.monthsRows(nextYearEvents)}
            </div>
          </div>
        ) : null}
      </React.Fragment>
    )
  }
}

export default List
